// This file ensures all providers are loaded
import "./openai";
import "./anthropic";
import "./google";
import "./custom";
import { providerRegistry } from "../utils/providers";

// Log the number of loaded providers
const providerCount = providerRegistry.getAll().length;
console.log(`Loaded ${providerCount} AI providers`);

// Export the provider registry for convenience
export { providerRegistry } from "../utils/providers";

// This function can be called to ensure providers are loaded
export function ensureProvidersLoaded(): number {
  return providerRegistry.getAll().length;
}
